module.exports = __webpack_public_path__ + "media/images/products/products/f1-beace13d9c8d06dfb8a6cc2cfb929b5d.jpg";